import { map } from 'rxjs/operators';
import { Endpoint } from '../endpoint';
import { ReportDataSource, ReportDataType, ReportDataQuery } from '@business/entities/dynamicReprots';
import { Paginate } from '@business/entities/common';
import { R } from '@core/utils/r';
import { Session } from '@modules/auth/session';

export function getData(data: ReportDataQuery) {
  const endpoint = Session.isAuthenticated ? `@gc/report-builder/get-data` : `@gc/public/report-builder/get-data`;
  return Endpoint.post<Paginate<ReportDataType>>(endpoint, { data });
}

export function downloadCSV(data: ReportDataQuery, inFile: string) {
  let filename = inFile;
  if (R.isEmpty(inFile)) {
    filename = 'report';
  }
  return Endpoint.post<Paginate<ReportDataType>>(`@gc/report-builder/download-data`, { data, isFile: true, filename: `${filename}.csv` });
}

/**
 * Every source picker reads this — building a widget, the report builder and
 * the graph source selector — so a deleted source is dropped once, here.
 *
 * The server still returns them, because a widget already built on a source
 * someone later deleted has to keep resolving and rendering. Only the choice
 * of a source for something new is withheld.
 */
export function fetchSources() {
  return Endpoint.get<ReportDataSource[]>(`@gc/report-builder/sources`).pipe(map(sources => (sources || []).filter(source => !source.deleted)));
}
